import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import AdditionalInfoSchema from "./validations/additionalInfoValidation";

import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";

import { addAdditionalInfo } from "../../api/auth";

import OnboardingStepHeader from "./OnboardingStepHeader";
import Sallie from "../UIComponents/Sallie";
import LabelledInput from "../UIComponents/LabelledInput";
import SelectField from "../UIComponents/SelectField";
import SubmitButton from "../UIComponents/SubmitButton";

import CountryList from "../../api/countryList.json";
import { UserContext } from "../../lib/main-context";

function AdditionalInfo({ setOnboardingPercent }) {
    setOnboardingPercent(85);

    const history = useHistory();
    const { user } = useContext(UserContext);
    const { t } = useTranslation();

    const {
        register,
        handleSubmit,
        errors,
        formState: { isSubmitting },
    } = useForm({ resolver: yupResolver(AdditionalInfoSchema) });

    const raceOptions = [
        { value: "", label: "" },
        { value: "American Indian or Alaskan Native", label: t("additionalinfo.race.americanIndian") },
        { value: "Asian Indian", label: t("additionalinfo.race.asianIndian") },
        { value: "Black or African American", label: t("additionalinfo.race.black") },
        { value: "Chamorro or Guamanian", label: t("additionalinfo.race.chamorro") },
        { value: "Chinese", label: t("additionalinfo.race.chinese") },
        { value: "Filipino", label: t("additionalinfo.race.filipino") },
        { value: "Japanese", label: t("additionalinfo.race.japanese") },
        { value: "Korean", label: t("additionalinfo.race.korean") },
        { value: "White", label: t("additionalinfo.race.white") },
        { value: "otherRace", label: t("additionalinfo.race.other") },
        { value: "Prefer not to answer", label: t("additionalinfo.race.preferNot") },
    ];

    const ethnicityOptions = [
        { value: "", label: "" },
        { value: "Yes", label: t("additionalinfo.ethnicity.yes") },
        { value: "No", label: t("additionalinfo.ethnicity.no") },
        { value: "otherEthnicities", label: t("additionalinfo.ethnicity.other") },
        { value: "notToAnswer", label: t("additionalinfo.ethnicity.preferNot") },
    ];

    const veteranOptions = [
        { value: "", label: "" },
        { value: "yes", label: t("additionalinfo.veteran.yes") },
        { value: "no", label: t("additionalinfo.veteran.no") },
        { value: "notToAnswer", label: t("additionalinfo.veteran.preferNot") },
    ];

    async function onSubmit(data) {
        await addAdditionalInfo({ ...data, userId: user.userId });
        if (user.userType !== "provider") {
            history.push("/Verification/EmailSent");
        } else {
            history.push("/PaymentPage");
        }
    }

    return (
        <>
            <OnboardingStepHeader text={t("additionalinfo.header")} />
            <Sallie text={t("additionalinfo.sallie")} />
            <Form
                className="mt-4"
                autoComplete="on"
                action="/post"
                method="POST"
                onSubmit={handleSubmit(onSubmit)}
            >
                <Row>
                    <Col md={6}>
                        <LabelledInput
                            name="phoneNumber"
                            type="tel"
                            label={t("additionalinfo.phone")}
                            autoComplete="tel"
                            inputRef={register}
                            errors={errors}
                        />
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="country">
                            <Form.Label>{t("additionalinfo.country")}</Form.Label>
                            <Form.Control name="country" as="select" ref={register} defaultValue="">
                                {Object.keys(CountryList).sort().map((countryName) => (
                                    <option key={CountryList[countryName]} value={CountryList[countryName]}>
                                        {countryName}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <SelectField
                            controlId="ethnicity"
                            label={t("additionalinfo.ethnicity.label")}
                            name="ethnicity"
                            options={ethnicityOptions}
                            register={register}
                            errors={errors}
                        />
                    </Col>
                    <Col md={4}>
                        <SelectField
                            controlId="race"
                            label={t("additionalinfo.race.label")}
                            name="race"
                            options={raceOptions}
                            register={register}
                            errors={errors}
                        />
                    </Col>
                    <Col md={4}>
                        <SelectField
                            controlId="veteran"
                            label={t("additionalinfo.veteran.label")}
                            name="veteran"
                            options={veteranOptions}
                            register={register}
                            errors={errors}
                        />
                    </Col>
                </Row>
                <SubmitButton disabled={isSubmitting} type="submit">
                    {`${t("onboarding.saveContinue")} >`}
                </SubmitButton>
            </Form>
        </>
    );
}

export default AdditionalInfo;